import * as React from "react";
const SvgFiRrPortalExit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-portal-exit_svg__a)">
      <path
        fill="#062147"
        d="M24 12a1 1 0 0 1-1 1h-2.229a3.02 3.02 0 0 1-2.571-1.453l-.564-.936-.941 2.294a1 1 0 0 1-1.851-.76l1.505-3.669a1 1 0 0 0-.85-.475h-.894l-2.064 5.033a1 1 0 0 0 .391 1.225l4.591 2.896c.29.184.466.502.466.846v5a1 1 0 1 1-2 0v-4.448l-4.126-2.604a3 3 0 0 1-1.173-3.675l1.753-4.273h-1.208a.99.99 0 0 0-.894.553l-1.447 2.895a1 1 0 0 1-1.789-.895l1.447-2.895a2.99 2.99 0 0 1 2.683-1.658h4.264c1.046 0 2.031.557 2.57 1.453l1.844 3.062c.18.299.508.484.857.484h2.229A1 1 0 0 1 24 12m-13.135 4.814a1 1 0 0 0-1.3.557 1 1 0 0 1-.929.629H4.543a1 1 0 0 0-.989.852c-.188 1.254-.393 2.043-.559 2.53-.458-1.379-.996-4.548-.996-9.382S2.541 3.978 3 2.605C3.459 3.977 4 7.15 4 12c0 .999-.025 1.991-.074 2.949a1 1 0 0 0 .947 1.05.997.997 0 0 0 1.05-.948C5.974 14.06 6 13.032 6 12 6 8.392 5.708 0 3 0S0 8.392 0 12s.292 12 3 12c1.153 0 1.884-1.207 2.391-4h3.245c1.233 0 2.327-.74 2.785-1.885a1 1 0 0 0-.556-1.301M17.99 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-portal-exit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPortalExit;
